module.exports = __webpack_public_path__ + "static/app_screen-5c702f58fd644df5e72c8c0846ad9177.png";